// components/TradingViewChart.js
import React, { useEffect, useRef } from "react";
import datafeed from "./datafeed"; // <-- your datafeed.js

const TradingViewChart = () => {
  const chartRef = useRef(null);

  useEffect(() => {
    // wait until TradingView scripts have injected themselves
    if (!window.TradingView || !window.Datafeeds) {
      console.error("TradingView or UDF Datafeeds not found");
      return;
    }

    const widget = new window.TradingView.widget({
      container: chartRef.current, // pass the element directly
      locale: "en",
      library_path: "/charting_library/",
      datafeed, // <-- your custom datafeed object
      symbol: "BTC/EUR", // Default symbol pair
      interval: "1D",
      fullscreen: true,
      debug: true,
    });

    return () => {
      if (widget) widget.remove();
    };
  }, []);

  return <div ref={chartRef} style={{ width: "100%", height: "100%", marginTop: '20px' }} />;
};

export default TradingViewChart;
